import type { Action } from 'redux';
import type { AdAccount } from '../../../../../main/types/adPartnerTypes';
import type { GetPinterestAdAccountsPayload } from '../Pinterest.types';
import { ReduxAsyncAction } from '../../../../services/ReduxAsyncAction';
import dash_api from '../../../../../main/support/dash_api';
import { isSavedAdAccount } from '../../../../../main/components/PartnerManager/utils';

const GetPinterestAdAccounts = new ReduxAsyncAction<'GET_PINTEREST_AD_ACCOUNTS', AdAccount[], GetPinterestAdAccountsPayload>(
  'GET_PINTEREST_AD_ACCOUNTS'
);
GetPinterestAdAccounts.registerRequest((savedAccounts: AdAccount[]) => {
  return dash_api.get('/v1/pinterest/get-accounts').then(({ data }) => {
    return {
      accounts: Array.isArray(data)
        ? data.map((account) => ({ ...account, checked: isSavedAdAccount(account.account_id, savedAccounts) }))
        : [],
    };
  });
});
export const GET_PINTEREST_AD_ACCOUNTS = GetPinterestAdAccounts.actionNamespaceConstants;
export const getPinterestAdAccounts = GetPinterestAdAccounts.request;

export type GetPinterestAdAccountsAction = Action<typeof GET_PINTEREST_AD_ACCOUNTS.response> & {
  data: GetPinterestAdAccountsPayload;
};
